import { get } from 'lodash';

const recursivePropAccess = (obj, propAccess, propValue) => {
  const copyObject = JSON.parse(JSON.stringify(obj));
  let objRef = copyObject;
  propAccess
    .replace('[', '.')
    .replace(']', '')
    .split('.')
    .forEach((prop, i, arr) => {
      if (i < arr.length - 1) {
        objRef = objRef[prop];
      } else {
        objRef[prop] = propValue;
      }
    });
  return copyObject;
};

export const setLoanDataValue = (value, route) => (dispatch, state) => {
  const loanData = get(state(), 'EPPS.loanInfo') || {};
  dispatch({
    type: 'UPDATE_LOANINFO',
    payload: recursivePropAccess(loanData, route, value),
  });
};

export const setLoanDataValueMultiple = (operations) => (dispatch, state) => {
  const loanData = { ...(get(state(), 'EPPS.loanInfo') || {}) };

  dispatch({
    type: 'UPDATE_LOANINFO',
    payload: []
      .concat(...operations)
      .reduce(
        (sum, { value, pathValue }) =>
          recursivePropAccess(sum, pathValue, value),
        loanData,
      ),
  });
};

export const setLoanInfo = (value) => (dispatch) => {
  dispatch({
    type: 'UPDATE_LOANINFO',
    payload: value,
  });
};
